import { render, staticRenderFns } from "./LooseThreads.vue?vue&type=template&id=c1ba28f4&scoped=true&"
import script from "./LooseThreads.vue?vue&type=script&lang=js&"
export * from "./LooseThreads.vue?vue&type=script&lang=js&"
import style0 from "./LooseThreads.vue?vue&type=style&index=0&id=c1ba28f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ba28f4",
  null
  
)

export default component.exports